import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { fadeInUp, standardViewport } from '../../utils/animation';
import './ContactHeader.scss';

const ContactHeader = () => {
  const { t } = useTranslation('contact');
  
  return (
    <section className="contact-header">
      <motion.h1 
        className="contact-title"
        initial="hidden"
        whileInView="visible"
        viewport={standardViewport}
        variants={fadeInUp}
      >
        {t('header.title')}
      </motion.h1>
    </section>
  );
};

export default ContactHeader;
